(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('DeliveryTrackController', DeliveryTrackController);

    DeliveryTrackController.$inject = ['$q', '$scope', 'OrderTraces', '$state', 'MessageService', 'SalesOrder','$uibModalInstance', 'entity', 'type', 'LocationCity', 'LocationDistrict', 'OrderPack'];

    function DeliveryTrackController ($q, $scope, OrderTraces, $state, MessageService, SalesOrder, $uibModalInstance, entity, type, LocationCity, LocationDistrict, OrderPack) {
        var vm = this;
        vm.salesOrder = entity;
        vm.trackData = []
        vm.type = type //供应商物流
        $q.all([vm.salesOrder.$promise]).then(function(){
            init();
        });

        function init() {
            OrderTraces.byOrderId({orderId:vm.salesOrder.id,supplier:vm.type == 'supplier'}, function (res) {
                if(res && res.length>0 && res[0].traces){
                    vm.trackData = res[0].traces;
                }
            })
        }
        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };

        $scope.save = function() {
            vm.orderPack.orderLocation.address = vm.province.name+"-"+vm.city.name+"-"+vm.district.name+"-"+vm.address;
            OrderPack.updateOrderLocation(vm.orderPack, function(data){
                MessageService.success("修改成功！");
                $uibModalInstance.close(true);
            });
        }
    }
})();
